import React, { useState } from 'react';
import {
  TabList,
  Tab,
  makeStyles,
  Title3,
} from '@fluentui/react-components';
import SchoolsList from '../../components/Education/SchoolsList';
import ClassesList from '../../components/Education/ClassesList';
import UsersList from '../../components/Education/UsersList';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px',
  },
  header: {
    marginBottom: '8px',
  },
  tabContent: {
    marginTop: '16px',
  },
});

type TabValue = 'schools' | 'classes' | 'users';

export const EducationPage: React.FC = () => {
  const styles = useStyles();
  const [selectedTab, setSelectedTab] = useState<TabValue>('schools');

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Title3>Microsoft 365 Education</Title3>
      </div>

      <TabList
        selectedValue={selectedTab}
        onTabSelect={(_, data) => setSelectedTab(data.value as TabValue)}
      >
        <Tab value="schools">Escolas</Tab>
        <Tab value="classes">Turmas</Tab>
        <Tab value="users">Usuários</Tab>
      </TabList>

      <div className={styles.tabContent}>
        {selectedTab === 'schools' && <SchoolsList />}
        {selectedTab === 'classes' && <ClassesList />}
        {selectedTab === 'users' && <UsersList />}
      </div>
    </div>
  );
};

export default EducationPage;
